import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ThongBao } from 'src/app/shared/ThongBao.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ThongBaoService extends BaseService{

    list: ThongBao[] | undefined;
    list001: ThongBao[] | undefined;
    formData!: ThongBao;    

    displayColumns001: string[] = ['STT', 'ID', 'Name', 'Description', 'BatDau', 'KetThuc', 'Active', 'Save'];    

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ThongBao";
    }
}

